/* global jQuery */
import plugin from "@core/plugins/lib";
import debug from "debug";

const ELEMENT_SELECTOR = "[data-cover-selector]";
const PLUGIN_NAME = "coverSelector";

const log = debug(PLUGIN_NAME);

class CoverSelector {
	constructor(element, options) {
		log("element", element);
		log("options", options);

		this.options = options;
		this.form = element;

		this.inclusionsToggles = [
			...this.form.querySelectorAll(this.options.inclusionsToggleSelector)
		];
		this.exclusionsToggles = [
			...this.form.querySelectorAll(this.options.exclusionsToggleSelector)
		];
		this.prioritiesToggles = [
			...this.form.querySelectorAll(this.options.prioritiesToggleSelector)
		];
		this.errorMessage = this.form.querySelector(
			this.options.errorMessageSelector
		);
		this.submitLabel = this.form.querySelector(this.options.submitLabelSelector);

		// Elements that may have error messages to display
		this.componentErrorCollection = [
			...this.form.querySelectorAll(this.options.componentErrorSelector)
		];

		this.items = [...this.form.querySelectorAll(this.options.itemSelector)];
		this.choiceResultInput = this.form.querySelector(
			this.options.choiceResultInputSelector
		);

		// Status element may not exist
		// Only wire up methods if it does
		this.status = this.form.querySelector(this.options.statusSelector);
		this.updateStatus = this.status
			? this.updateStatusMethod
			: ()=>{};
		this.updateStatusFrequency = this.status
			? this.updateStatusFrequencyMethod
			: ()=>{};

		this.watch();
		log("ready", this, this.form);
	}

	watch() {
		log("watching");

		this.form.addEventListener("change", this.onFormChange.bind(this));
		$(this.form).on("coverchange", this.onCoverChange.bind(this));
		$(this.form).on(
			"toggleinclusions",
			this.toggleCollapsibles.bind(this, this.inclusionsToggles)
		);
		$(this.form).on(
			"toggleexclusions",
			this.toggleCollapsibles.bind(this, this.exclusionsToggles)
		);
		$(this.form).on(
			"togglepriorities",
			this.toggleCollapsibles.bind(this, this.prioritiesToggles)
		);
		this.form.addEventListener("submit", this.onFormSubmit.bind(this));
	}

	onFormSubmit(event) {
		const choiceValue = this.form.elements[this.options.choiceInputName]
			.value;
		if (!choiceValue) {
			event.preventDefault();
			this.errorMessage.hidden = false;
		}
	}

	toggleCollapsibles(toggles, event) {
		log("toggle", arguments);

		const sourceToggle = event.target;
		const targetToggles = toggles.filter(toggle => {
			return toggle !== sourceToggle;
		});

		targetToggles.forEach(toggle => {
			toggle.dataset.collapsibleOpen =
				sourceToggle.dataset.collapsibleOpen;
		});
	}

	onFormChange(event) {
		log("onFormChange", event);

		this.updateProductDisplay();

		// Consider moving this to submit event?
		this.getSelectedProduct();
	}

	updateProductDisplay() {
		const chosenProductId = this.form.elements[this.options.choiceInputName]
			.value;

		// abort if not chosen yet
		if (!chosenProductId) {
			return false;
		}

		const chosenItem = this.items.find(item => {
			return (
				item.dataset["target-CoverSelector"] ===
				`item:${chosenProductId}`
			);
		});

		this.updateStatus(chosenItem);
		this.updateSubmitLabel(chosenItem);

	}

	updateStatusMethod(chosenItem) {
		// TODO: move these to config or data attr
		const rateToUpdate = {
			hospital: "quoteStatus-HospitalRates",
			extras: "quoteStatus-ExtrasRates"
		};
		const nameToUpdate = {
			hospital: "quoteStatus-HospitalName",
			extras: "quoteStatus-ExtrasName"
		};

		// rates (one of hospital/extras)
		const productRates = chosenItem.dataset["compareSummary-SyncRates"];
		this.status.dataset[
			rateToUpdate[this.options.choiceInputName]
		] = productRates;

		// name (one of hospital/extras)
		const productName = chosenItem.dataset["compareSummary-Name"];
		this.status.dataset[
			nameToUpdate[this.options.choiceInputName]
		] = productName;

		const noExtras = chosenItem.dataset["compareSummary-NoExtras"] === 'true';
		this.status.dataset["quoteStatus-NoExtras"] = noExtras;
	}

	updateStatusFrequencyMethod(frequency){
		this.status.dataset["quoteStatus-Frequency"] = frequency;
	}

	updateSubmitLabel(chosenItem) {
		const buttonLabel = chosenItem.dataset['compareSummary-SubmitLabel'];
		if (buttonLabel && this.submitLabel) {
			this.submitLabel.textContent = buttonLabel;
		}
	}

	onCoverChange(event) {
		log("onCoverChange", event);

		const updatedItem = event.target;
		const itemsToUpdate = this.items.filter(item => {
			return item !== updatedItem;
		});

		// Sync values to other summary items
		itemsToUpdate.forEach(item => {
			this.options.itemDataSync.forEach(attr => {
				item.dataset[attr] = updatedItem.dataset[attr];
			});
		});

		// updating status frequency even if no extras selected (hospital may have been)
		// will update using existing values
		const frequency = updatedItem.dataset["compareSummary-SyncFrequency"];
		this.updateStatusFrequency(frequency);
		this.updateProductDisplay();
	}

	getSelectedProduct() {
		//	Extras don't need this field as we can get value from choose input directly
		if (!this.options.choiceResultInputSelector || !this.choiceResultInput) {
			return false;
		}

		const productId = this.form.elements[this.options.choiceInputName]
			.value;
		const excessOptions = this.form.elements[
			`${this.options.excessRadioNamePrefix}${productId}`
		];

		log("selected product: ", excessOptions);
		this.choiceResultInput.value = excessOptions ? excessOptions.value : "";
	}
}

CoverSelector.DEFAULTS = {
	excessRadioNamePrefix: "cover_"
};

plugin(PLUGIN_NAME, CoverSelector);
$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/core/modules/cover-selector/components/cover-selector/cover-selector.js